import React from 'react';
import SectionTitle from '../../../components/section-title';
import CustomImage from '../../../components/custom-image';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const Asignificant = () => {
  return (
    <div className="asignificant">
      <div className="container">
        <div className="container-inner">
          <SectionTitle
            lighttext="A SIGNIFICANT"
            boldtext="CONTRIBUTOR TO INDIA’S LARGE ECONOMY"
            isSectionH1={false}
          ></SectionTitle>
          <div className="contribution-content">
            <div className="content-row">
              <div className="column-20">
                <ScrollPositionAnimation targetElement1="anim-7">
                  <div className="left-to-right anim-7">
                    <div className="title">
                      <h3>Vedanta’s GDP Contribution</h3>
                    </div>
                    <div className="impact-percent">
                      <div className="impact-text c-blue">
                        2.2% <span>INDUCED IMPACT</span>
                      </div>
                      <div className="impact-text c-green">
                        0.40% <span>DIRECT IMPACT</span>
                      </div>
                      <div className="impact-text clight-blue">
                        1.0% <span>INDIRECT IMPACT</span>
                      </div>
                    </div>
                  </div>
                </ScrollPositionAnimation>
              </div>
              <div className="column-50">
                <ScrollPositionAnimation targetElement2="anim-8">
                  <div className="image-box">
                    <div className="bottom-to-top anim-8">
                      <CustomImage
                        className="custom-image"
                        imageName="india-map.png"
                        maxWidth="(max-width: 475)"
                        alt="A Significant Contributor To India’s Large Economy"
                      />
                    </div>
                  </div>
                </ScrollPositionAnimation>
              </div>
              <div className="column-30">
                <ScrollPositionAnimation targetElement1="anim-9">
                  <div className="right-to-left anim-9">
                    <div className="description-p">
                      <p>
                        Vedanta influences consumption patterns of employees and suppliers by generating jobs and creating induced impact on India’s economy, equivalent to 
                        <span className="text-blue"> 2.20% of the country’s GDP</span>
                      </p>
                      <p>
                        Vedanta <span className="text-green">directly contributes 0.40 percent to India’s GDP</span>{' '}
                        through it’s operation
                      </p>
                      <p>
                        The indirect impact of the company through it’s supplier network is as large as
                        <span className="text-light-blue"> 1 percent of India’s GDP</span>
                      </p>
                    </div>
                  </div>
                </ScrollPositionAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Asignificant;
